import React, { useMemo } from "react"
import { resolveTable } from "../../model/resolve"
import { useTabSpecStore } from "../../runtime/tabSpecStore"
import DraftInput from "./DraftInput.component"
import Field from "./Field.component"
import { useInspectedTable } from "./useInspectedTable"

/**
 * The table's own title and its note. The title field shows the generated
 * title until one is typed; emptying either field removes it. Both write
 * when the field is left.
 */
const NotesTab: React.FC<{ tableId: string }> = ({ tableId }) => {
  const inspected = useInspectedTable(tableId)
  const updateTable = useTabSpecStore((s) => s.updateTable)
  const clearOverrides = useTabSpecStore((s) => s.clearOverrides)
  const generated = useMemo(() => {
    if (!inspected) return ""
    const { table, document, catalogue } = inspected
    return resolveTable({ ...table, title: undefined }, document, catalogue).title
  }, [inspected])
  if (!inspected) return null
  const { table } = inspected

  return (
    <div className="ts-tab">
      <Field label="Title">
        <DraftInput
          ariaLabel="Title"
          placeholder={generated}
          value={table.title ?? ""}
          onCommit={(text) =>
            text.trim()
              ? updateTable(tableId, { title: text.trim() })
              : clearOverrides(tableId, ["title"])
          }
        />
      </Field>
      <Field label="Note">
        <DraftInput
          multiline
          ariaLabel="Note"
          placeholder="Shown under the table in the tab book"
          value={table.note ?? ""}
          onCommit={(text) =>
            text.trim()
              ? updateTable(tableId, { note: text.trim() })
              : clearOverrides(tableId, ["note"])
          }
        />
      </Field>
    </div>
  )
}

export default NotesTab
